import type { UIKitTheme } from '@sendbird/uikit-react-native-foundation';
import { colorPalette } from './colorsConfig';

export const applyChatBubbleColors = (theme: UIKitTheme) => {
    const { incoming, outgoing } = theme.colors.ui.groupChannelMessage;

    for (const state of [incoming.enabled, incoming.pressed]) {
        state.background = state === incoming.enabled ? colorPalette.gray[200] : colorPalette.gray[300];
        state.textMsg = colorPalette.black;
        state.textSenderName = colorPalette.black;
        state.textTime = colorPalette.gray[500];
    }
    for (const state of [outgoing.enabled, outgoing.pressed]) {
        state.background = state === outgoing.enabled ? colorPalette.secondary[100] : colorPalette.secondary[300];
        state.textMsg = colorPalette.black;
        state.textTime = colorPalette.gray[500];
    }
};
